import { IAuthParams, IAuthParsedParams } from 'store/Auth/interfaces';
import { availableOddsFormats, BettingOptionsFormat } from 'enums/BettingOptionsFormat';
import { Theme } from 'enums/Theme';
import { PlatformID } from 'integrations/enums/PlatformID';

const TIMEZONE_UPPER_LIMIT = 14;
const TIMEZONE_LOWER_LIMIT = -12;

export const validateAuthParams = (params: IAuthParams): IAuthParsedParams => {
    const timezone = Number.isNaN(Number(params.timezone)) ? 0 : Number(params.timezone);

    return {
        ...params,
        timezone: Math.min(
            Math.max(timezone, TIMEZONE_LOWER_LIMIT),
            TIMEZONE_UPPER_LIMIT,
        ).toString(),
        locale: params.locale?.toLowerCase(),
        oddsFormat: availableOddsFormats.includes(params.oddsFormat as BettingOptionsFormat)
            ? (params.oddsFormat as BettingOptionsFormat)
            : BettingOptionsFormat.DECIMAL,
        theme: [Theme.DARK, Theme.LIGHT].includes(params.theme) ? params.theme : undefined,
        showBalance: !Number.isNaN(Number(params.showBalance))
            ? Boolean(Number(params.showBalance))
            : true,
        dynamicHeight: !Number.isNaN(Number(params.dynamicHeight))
            ? Boolean(Number(params.dynamicHeight))
            : false,
        showLogo: !Number.isNaN(Number(params.showLogo)) ? Boolean(Number(params.showLogo)) : true,
        gui: !Number.isNaN(Number(params.gui)) ? Boolean(Number(params.gui)) : false,
        platformID: Object.values(PlatformID).includes(Number(params.platformID))
            ? Number(params.platformID)
            : PlatformID.DESKTOP,
    };
};
